import { createSelector } from 'reselect';

const selectTaxProviders = (state: any) => state.taxProviders;


export const selectCurrentItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.current);

export const selectListItems = createSelector([selectTaxProviders], (taxProviders) => taxProviders.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.create);

export const selectUpdatedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.update);

export const selectReadItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.read);

export const selectDeletedItem = createSelector([selectTaxProviders], (taxProviders) => taxProviders.delete);

export const selectSearchedItems = createSelector([selectTaxProviders], (taxProviders) => taxProviders.search);

export const selectItemsCount = createSelector([selectTaxProviders], (taxProviders) => taxProviders.count);

export const selectItemsFilter = createSelector([selectTaxProviders], (taxProviders) => taxProviders.filter);